export function resetPanel(system, panel) {
  panel.style.transform = '';
  panel.style.width = '';
  panel.style.height = '';
  panel.style.willChange = '';
  system.saveLayout();
}

export function toggleMinimize(system, panel) {
  const isMinimized = panel.classList.toggle('minimized');
  const btn = panel.querySelector('.minimize-btn');
  if (btn) {
    btn.textContent = isMinimized ? '+' : '–';
    btn.setAttribute('aria-label', isMinimized ? 'Restore Panel' : 'Minimize Panel');
  }
  if (isMinimized) {
    panel.style.transform = '';
  } else {
    void panel.offsetWidth;
    system.clampPanelPosition(panel);
  }
  system.saveLayout();
}

export function minimizeAll(system) {
  document.querySelectorAll('.panel:not(.hidden-panel)').forEach((panel) => {
    if (!panel.classList.contains('minimized')) system.toggleMinimize(panel);
  });
}

export function restoreAll(system) {
  document.querySelectorAll('.panel.minimized').forEach((panel) => {
    system.toggleMinimize(panel);
  });
}

export function resetAll(system) {
  const panels = document.querySelectorAll('.panel');
  panels.forEach(panel => {
    panel.style.transform = '';
    panel.style.width = '';
    panel.style.height = '';
    panel.style.willChange = '';
    panel.classList.remove('dragging');
  });
  system.currentTranslateX = 0;
  system.currentTranslateY = 0;
  system.saveLayout();
}
